import { Navigate } from "react-router";
import { cache } from ".";
import { ReactElement } from "react";

interface PrivateRouteProps {
  children: ReactElement;
}

export default function PrivateRoute({ children }: PrivateRouteProps) {
  const user = cache.get("USER");

  return user ? children : <Navigate to="/" replace />;
}
